export default __webpack_public_path__ + "static/media/Methodology.88255569.png";